// removed by extract-text-webpack-plugin
module.exports = {"container":"_2ZGIi","image":"_2_Tht"};


//////////////////
// WEBPACK FOOTER
// ./app/components/header-avatar-image/header-avatar-image.scss
// module id = 1488
// module chunks = 0